import React from 'react';
import classNames from 'classnames';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import styles from './list-item-container.module.scss';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
const ListItemContainer = React.forwardRef(({ id, isMarked, isReply, dataHook, isPending, children, className }, ref) => {
    const { screenshotMode } = useConfiguration();
    const isMobile = useApi(getIsMobile);
    return (React.createElement("div", { ref: ref, tabIndex: -1, id: id, "data-hook": dataHook, className: classNames(styles.root, isMobile && styles.isMobile, isPending && styles.isPending, isReply && styles.isReply, !!screenshotMode && styles.noTransitions, !!isMarked && styles.isMarked, className) },
        React.createElement("div", { className: classNames(styles.highlight, 'wc-comment-highlight') }),
        React.createElement("div", { className: styles.innerContainer }, children)));
});
export default ListItemContainer;
//# sourceMappingURL=list-item-container.js.map